/**
 * @Author : zhouqinze
 * @Date : 2019-12-28
 * @Version : 1.0
 * @Content : 加入我们
 **/
<template>
    <div>
        <div class="aboutComHead">
            <p>加入我们</p>
            <p><span></span><span></span></p>
        </div>
        <div class="joinCon">
            <div><p>公司长期培养计算机、大数据、图像识别、项目管理等各类科技人才，并可办理“广州市人才引进入户”手续。</p><p>欢迎各大院校联系洽谈实习、就业、委培等事宜。</p></div>
            <div><p>联系人：常烨文</p><p>电话：020-38481073</p></div>
            <div><p>相关招聘信息见前程无忧招聘网站，搜索关键字：广州通易科技</p></div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    .aboutComHead{
        width: 5.875rem;
        font-size: 1.4375rem;
        color: #333;
        margin-bottom: .75rem;
        font-weight: bold;
        span{
            display: inline-block;
            width: 50%;
            height: .1875rem;
            background: #018CF4;
        }
        span:last-child{
            background: #ddd;
        }
    }
    .joinCon{
        div{
            padding: 1.25rem 0;
            text-align: left;
            p{
                font-size: 1rem;
                line-height: 1.375rem;
                height: 1.375rem;
                color: #333;
            }
        }
    }
</style>